export default __webpack_public_path__ + "static/media/info-rounded.6c2f7b20.svg";